// frontend/src/hooks/useAuthToken.js
import { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function useAuthToken() {
  const [token, setToken] = useState(() => {
    // Check both possible keys for backwards compatibility
    return localStorage.getItem('authToken') || localStorage.getItem('auth_token');
  });

  // Listen for token updates (storage events + custom events)
  useEffect(() => {
    const handleTokenUpdate = () => {
      const newToken = localStorage.getItem('authToken') || localStorage.getItem('auth_token');
      setToken(newToken);
    };

    // Listen for storage events (from other tabs)
    window.addEventListener('storage', handleTokenUpdate);
    
    // Listen for custom token refresh events (same tab)
    window.addEventListener('tokenRefresh', handleTokenUpdate);

    return () => {
      window.removeEventListener('storage', handleTokenUpdate);
      window.removeEventListener('tokenRefresh', handleTokenUpdate);
    };
  }, []);

  return token;
}

// Utility function to update token and notify all components
export const updateAuthToken = (newToken) => {
  localStorage.setItem('authToken', newToken);
  // Clean up old key for consistency
  localStorage.removeItem('auth_token');
  // Dispatch custom event to notify all useAuthToken hooks
  window.dispatchEvent(new CustomEvent('tokenRefresh'));
};

export const useLogout = () => {
  const navigate = useNavigate();

  const logout = useCallback(() => {
    localStorage.removeItem('auth_token');
    toast.success('You have been logged out');
    navigate('/login');
  }, [navigate]);

  return logout;
};